// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__25eho","filesListContainer":"PosDisputesFiles_filesListContainer__lVAYc","filesButton":"PosDisputesFiles_filesButton__3-7fz"};